import { useState, useRef, useEffect } from 'react';
import { Modal } from '@/components/ui/Modal';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';

interface CloneCampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
  loading: boolean;
}

export function CloneCampaignModal({ isOpen, onClose, onConfirm, loading }: CloneCampaignModalProps) {
  const [name, setName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) {
      setName('');
      requestAnimationFrame(() => inputRef.current?.focus());
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed && !loading) onConfirm(trimmed);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Clone Campaign"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!name.trim() || loading} loading={loading}>
            Clone
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <Input
          ref={inputRef}
          label="Campaign Name"
          required
          placeholder="Enter a name for the cloned campaign"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
      </form>
    </Modal>
  );
}
